import { useContext } from 'react';
import { isVrboOfflineLead } from 'utils/lead/leadUtils';
import InboxContext from '../InboxContext';
import InboxMessagesContext from './InboxMessagesContext';
import InboxMessagesList from './InboxMessagesList';
import useInboxNewMessagesCheck from './useInboxNewMessagesCheck';
import InboxMessageEditor from './editor/InboxMessageEditor';
import InboxMessageTemplates from './templates/InboxMessageTemplates';
import InboxMessagesLoader from './InboxMessagesLoader';
import InboxVrboOfflineBookingAlert from './InboxVrboOfflineBookingAlert';

const InboxMessagesBody = () => {
  const { activeMessageThreadUid, activeLead } = useContext(InboxContext);
  const { isLoading, isTemplateSelectorActive } =
    useContext(InboxMessagesContext);

  useInboxNewMessagesCheck();

  if (!activeMessageThreadUid) {
    return null;
  }

  return (
    <>
      {isLoading && <InboxMessagesLoader />}
      {!isLoading && (
        <>
          {isVrboOfflineLead(activeLead) && <InboxVrboOfflineBookingAlert />}
          <InboxMessageEditor />
          {isTemplateSelectorActive && <InboxMessageTemplates />}
          {!isTemplateSelectorActive && <InboxMessagesList />}
        </>
      )}
    </>
  );
};

export default InboxMessagesBody;
